import ServerApi from './$server.api'

export default {
    createQuotation,
    createShipment,
    findQuotation
}

async function createQuotation(data) {
    return await ServerApi.request('post', '/requests/quotation', {data})
}

async function createShipment(data) {
    return await ServerApi.request('post', '/requests/shipment', {data})
}

async function findQuotation(data) {
    return await ServerApi.request('post', '/quotation', {data})
}